import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * @typedef {object} Refs
 * @property {HTMLButtonElement} checkoutButton
 * @property {HTMLInputElement} [agreementCheckbox]
 * @property {HTMLElement} [expressCheckout]
 */

/**
 * @extends {Component<Refs>}
 */
class CartCheckoutAgreement extends Component {
  requiredRefs = ['checkoutButton'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate);
  }

  /**
   * The agreement checkbox opts out of morphing (`data-skip-node-update`) so an
   * unrelated cart change doesn't silently re-lock a shopper who already agreed.
   * Re-sync the checkout button against its live state after every cart morph instead.
   * @param {import('@shopify/events').CartLinesUpdateEvent} event
   */
  #handleCartUpdate = (event) => {
    event.promise
      ?.then(() => {
        if (this.refs.agreementCheckbox) this.toggleAgreement();
      })
      .catch(() => {});
  };

  toggleAgreement() {
    const { agreementCheckbox, checkoutButton, expressCheckout } = this.refs;
    const agreed = agreementCheckbox?.checked ?? false;

    checkoutButton.disabled = !agreed;
    expressCheckout?.toggleAttribute('inert', !agreed);
  }
}

if (!customElements.get('cart-checkout-agreement-component')) {
  customElements.define('cart-checkout-agreement-component', CartCheckoutAgreement);
}
